// src/widgetConfigInit.ts
import { v4 } from 'uuid';
import { getClientInfo } from '../services/authService';
import { sendStatistics } from '../services/dataColectorService';
import {logDebug, logError, logRisk, logTrace, setLogLevels} from './logger';
import ColorTheme from './ColorThemes.json';
import '../Customization.scss';
import ReactDOM from "react-dom/client";

export const initializeWidgetConfig = async (contextValueIn:any = null) => {
  sessionStorage.setItem("session_ID", v4().substring(0, 8));
sessionStorage.setItem("message_id", "0");
    const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const locale_messages = new Map<string, any>(Object.entries(require('../ds/locale.json')));
// Create a style element before React initialization
const bodyStyle = document.createElement('style');
  // Destructure to get rootStyle and contextValue

  document.head.appendChild(bodyStyle);


  const params = new URLSearchParams(window.location.search);
  const serializedWidgetParams = params.get('widget_params');

  let widgetParams = null;
  if (serializedWidgetParams) {
    try {
      widgetParams = JSON.parse(decodeURIComponent(serializedWidgetParams));
    } catch (error) {
      logError('Error deserializing widget parameters:', error);
    }
  } else {
    logDebug('widget_params not found in the URL');
  }

  const floatingWidget_states = [
    { name: 'minimized', duration: 10000 },//10 seconds
    { name: 'branded', duration: 5000 }, //5 seconds
    { name: 'minimized', duration: 1000 },//1 second
    { name: 'teaser', duration: 5000 },//5 seconds
    { name: 'open', duration: 0 }//0 seconds
  ];

  let userId = contextValueIn ? contextValueIn?.userId : params.get("userId") || widgetParams?.userId || "defaultUser",
      user_class = contextValueIn ? contextValueIn?.user_class : params.get("user_class") || widgetParams?.user_class ||  "default",
    client_token = contextValueIn ? contextValueIn?.client_token : params.get("client_token") || widgetParams?.client_token ||  "defaultToken",
    article_index = contextValueIn ? contextValueIn?.article_index : params.get("article_index") || widgetParams?.article_index ||  null,
    proxy = contextValueIn ? contextValueIn?.proxy : params.get("proxy") || widgetParams?.proxy ||   "",
    follow_up_question = contextValueIn ? contextValueIn?.follow_up_question : params.get("follow_up_question") || widgetParams?.follow_up_question ||  null,
    languageForWidget = contextValueIn && contextValueIn.language_for_widget !== undefined ?  contextValueIn.language : params.get("language") || widgetParams?.language ||  null,
    languageForChat = contextValueIn && contextValueIn.language_for_chat !== undefined ? contextValueIn.language_for_chat : params.get("language_for_chat") || widgetParams?.language_for_chat || null,
    floatingState = params.get("floatingState") || widgetParams?.floatingState  || floatingWidget_states,
    asset_type =  contextValueIn ? contextValueIn?.asset_type : params.get("assetType") || widgetParams?.assetType ||  null,
    asset_symbol = contextValueIn ? contextValueIn?.asset_symbol : params.get("assetSymbol") || widgetParams?.assetSymbol ||  null,
    follow_up_questions = params.get("follow_up_questions") || widgetParams?.follow_up_questions || null,
    color_theme = contextValueIn ? contextValueIn?.color_theme : params.get("color_theme") || widgetParams?.color_theme ||  null,
    widgetCustomizationData,
    data,
    client_id = "defaultClient",
    error_message = "",
    should_present_legal_banner = false,
    welcome_message;

  if (!client_token) client_token = "defaultToken";
  if (!userId) userId = "defaultUser";
  languageForWidget = languageForWidget === "NULL" ? null : languageForWidget;

  if (!languageForWidget) data = await getClientInfo(proxy, userId, client_token);

  if (!data) {
    widgetCustomizationData = {};
  } else {
    setLogLevels(data.log_level || '', { user_id: userId, user_class:user_class, client_id: data.client_name, client_token: client_token, proxy: proxy });
    if(userId === "defaultUser")
        logRisk("params:",params, "widgetParams:",widgetParams, "contextValueIn:",contextValueIn)
    logTrace(widgetParams)
    widgetCustomizationData = data.widget_config;
    if (color_theme) {
        if (Array.isArray(widgetCustomizationData)) {
            const matchedItem = widgetCustomizationData.find(item => item.color_theme === color_theme);
            widgetCustomizationData = matchedItem ? matchedItem : widgetCustomizationData[0];
        }
    }

    client_id = data.client_name;
    error_message = widgetCustomizationData.error_message;
    should_present_legal_banner = contextValueIn?.should_present_legal_banner || data.should_present_legal_banner;
    const welcome_message_per_client_from_db = widgetCustomizationData.welcome_message || null;
    const languageKey = languageForChat || "EN";
    const welcomeMessage = welcome_message_per_client_from_db || locale_messages.get(languageKey)?.welcome_message;
    welcome_message = data.is_new_user_for_welcome ? welcomeMessage : null;
    if (!client_id) client_id = "defaultClient";
  }

  if (follow_up_question && article_index)
    sendStatistics(proxy, client_id, userId, client_token, { 'ARTICLE_WIDGET_ACTIVATION': 1, 'article_index': article_index }, false);
  else if (follow_up_question)
    sendStatistics(proxy, client_id, userId, client_token, { 'ASSET_WIDGET_ACTIVATION': 1 }, false);

  let lclObj: any = null;
  if(!color_theme)
        widgetCustomizationData.color_theme = languageForChat && !widgetCustomizationData.color_theme ? "lightTheme" :  widgetCustomizationData.color_theme
   // else

  sessionStorage.setItem('userTheme', widgetCustomizationData.color_theme);
  switch (widgetCustomizationData.color_theme) {
    case 'lightTheme':
      lclObj = ColorTheme['lightTheme'];
      break;
    case 'darkTheme':
      lclObj = ColorTheme['darkTheme'];
      break;
    default:
      lclObj = ColorTheme['lightTheme'];
      break;
  }

  if (!widgetCustomizationData.color_theme)
  widgetCustomizationData.color_theme = "default"
if(!widgetCustomizationData.overlay_clr)
    widgetCustomizationData.overlay_clr = "default"
if(!widgetCustomizationData.overlay_menu_background_clr)
    widgetCustomizationData.overlay_menu_background_clr = "default"
if (!widgetCustomizationData.background_clr1)
  widgetCustomizationData.background_clr1 = "default"
if (!widgetCustomizationData.background_clr2)
  widgetCustomizationData.background_clr2 = "default"
if(!widgetCustomizationData.background_clr3 )
    widgetCustomizationData.background_clr3 = "default"
if (!widgetCustomizationData.main_btn_clr1)
  widgetCustomizationData.main_btn_clr1 = "default"
if (!widgetCustomizationData.main_btn_clr2)
  widgetCustomizationData.main_btn_clr2 = "default"
if (!widgetCustomizationData.main_btn_clr3)
  widgetCustomizationData.main_btn_clr3 = "default"
if (!widgetCustomizationData.main_btn_clr4)
  widgetCustomizationData.main_btn_clr4 = "default"
if(!widgetCustomizationData.main_btn_clr5 )
    widgetCustomizationData.main_btn_clr5 = "default"
if (!widgetCustomizationData.main_btn_shadow_clr)
  widgetCustomizationData.main_btn_shadow_clr = "default"
if (!widgetCustomizationData.secondary_btn_clr)
  widgetCustomizationData.secondary_btn_clr = "default"
if (!widgetCustomizationData.marked_followup_btn_clr)
  widgetCustomizationData.marked_followup_btn_clr = "default"
if (!widgetCustomizationData.tool_tip_background_clr)
  widgetCustomizationData.tool_tip_background_clr = "default"
if (!widgetCustomizationData.normal_text_clr)
  widgetCustomizationData.normal_text_clr = "default"
if (!widgetCustomizationData.ellipse_top)
  widgetCustomizationData.ellipse_top = "default"
if (!widgetCustomizationData.ellipse_bottom)
  widgetCustomizationData.ellipse_bottom = "default"
if (!widgetCustomizationData.colorful_text_clr1)
  widgetCustomizationData.colorful_text_clr1 = "default"
if (!widgetCustomizationData.colorful_text_clr2)
  widgetCustomizationData.colorful_text_clr2 = "default"
if (!widgetCustomizationData.negative_clr)
  widgetCustomizationData.negative_clr = "default"
if (!widgetCustomizationData.positive_clr)
  widgetCustomizationData.positive_clr = "default"
if (!widgetCustomizationData.markdown_background_clr)
  widgetCustomizationData.markdown_background_clr = "default"
if (!widgetCustomizationData.markdown_border_clr)
  widgetCustomizationData.markdown_border_clr = "default"
if(!widgetCustomizationData.arrow_background_clr )
    widgetCustomizationData.arrow_background_clr = "default"
if(!widgetCustomizationData.colorful_text_clr1 )
    widgetCustomizationData.colorful_text_clr1 = "default"
if(!widgetCustomizationData.colorful_text_clr2 )
    widgetCustomizationData.colorful_text_clr2 = "default"
if(!widgetCustomizationData.colorful_text_clr3 )
    widgetCustomizationData.colorful_text_clr3 = "default"
if(!widgetCustomizationData.negative_clr )
    widgetCustomizationData.negative_clr = "default"
if(!widgetCustomizationData.positive_clr )
    widgetCustomizationData.positive_clr = "default"
if(!widgetCustomizationData.transparent_wclr )
    widgetCustomizationData.transparent_wclr = "default"
if(!widgetCustomizationData.markdown_background_clr1 )
    widgetCustomizationData.markdown_background_clr1 = "default"
if(!widgetCustomizationData.markdown_background_clr2 )
    widgetCustomizationData.markdown_background_clr2 = "default"
if(!widgetCustomizationData.markdown_background_clr3 )
    widgetCustomizationData.markdown_background_clr3 = "default"
if(!widgetCustomizationData.markdown_border_clr )
    widgetCustomizationData.markdown_border_clr = "default"
if(!widgetCustomizationData.markdown_text_clr1 )
    widgetCustomizationData.markdown_text_clr1 = "default"
if(!widgetCustomizationData.markdown_text_clr2 )
    widgetCustomizationData.markdown_text_clr2 = "default"
if(!widgetCustomizationData.markdown_text_clr3 )
    widgetCustomizationData.markdown_text_clr3 = "default"
if(!widgetCustomizationData.markdown_text_clr4 )
    widgetCustomizationData.markdown_text_clr4 = "default"
if(!widgetCustomizationData.markdown_text_clr5 )
    widgetCustomizationData.markdown_text_clr5 = "default"
if(!widgetCustomizationData.markdown_text_clr6 )
    widgetCustomizationData.markdown_text_clr6 = "default"
if(!widgetCustomizationData.markdown_text_clr7 )
    widgetCustomizationData.markdown_text_clr7 = "default"
if(!widgetCustomizationData.box_shadow_Clr1 )
    widgetCustomizationData.box_shadow_Clr1 = "default"
if(!widgetCustomizationData.box_shadow_Clr2 )
    widgetCustomizationData.box_shadow_Clr2 = "default"
if(!widgetCustomizationData.text_border_clr1 )
    widgetCustomizationData.text_border_clr1 = "default"
if(!widgetCustomizationData.text_border_clr2 )
    widgetCustomizationData.text_border_clr2 = "default"
if(!widgetCustomizationData.text_shadow_clr )
    widgetCustomizationData.text_shadow_clr = "default"
if(!widgetCustomizationData.quest_background_clr1 )
    widgetCustomizationData.quest_background_clr1 = "default"
if(!widgetCustomizationData.quest_background_clr2 )
    widgetCustomizationData.quest_background_clr2 = "default"
if(!widgetCustomizationData.user_background_clr )
    widgetCustomizationData.user_background_clr = "default"
if(!widgetCustomizationData.user_shadow_clr1 )
    widgetCustomizationData.user_shadow_clr1 = "default"
if(!widgetCustomizationData.user_shadow_clr2 )
    widgetCustomizationData.user_shadow_clr2 = "default"
if(!widgetCustomizationData.question_btn_border_clr1 )
    widgetCustomizationData.question_btn_border_clr1 = "default"
if(!widgetCustomizationData.question_btn_border_clr2 )
    widgetCustomizationData.question_btn_border_clr2 = "default"
if(!widgetCustomizationData.checked_border_clr1 )
    widgetCustomizationData.checked_border_clr1 = "default"
if(!widgetCustomizationData.checked_border_clr2 )
    widgetCustomizationData.checked_border_clr2 = "default"
if(!widgetCustomizationData.checked_shadow_clr )
    widgetCustomizationData.checked_shadow_clr = "default"
if(!widgetCustomizationData.codeBlock_background_clr )
    widgetCustomizationData.codeBlock_background_clr = "default"
if (!widgetCustomizationData.newchat_btn_clr)
  widgetCustomizationData.newchat_btn_clr = "default"
if (!widgetCustomizationData.send_button_clr)
  widgetCustomizationData.send_button_clr = "default"
if (!widgetCustomizationData.stop_button_clr)
  widgetCustomizationData.stop_button_clr = "default"
if (!widgetCustomizationData.icons_background_clr)
  widgetCustomizationData.icons_background_clr = "default"
if (!widgetCustomizationData.error_background_clr)
  widgetCustomizationData.error_background_clr = "default"
if (!widgetCustomizationData.error_shadow_clr)
  widgetCustomizationData.error_shadow_clr = "default"
if (!widgetCustomizationData.error_clr)
  widgetCustomizationData.error_clr = "default"
if(!widgetCustomizationData.disclaimer_background_clr)
    widgetCustomizationData.disclaimer_background_clr = "default"
if(!widgetCustomizationData.disclaimer_text_clr)
    widgetCustomizationData.disclaimer_text_clr = "default"
if (!widgetCustomizationData.init_quest_text_clr)
    widgetCustomizationData.init_quest_text_clr = "default"
if (!widgetCustomizationData.quest_text_clr)
    widgetCustomizationData.quest_text_clr = "default"
if(!widgetCustomizationData.shine_verbose_effect_clr)
    widgetCustomizationData.shine_verbose_effect_clr = "default"

if (!widgetCustomizationData.sidebar_position_flag)
  widgetCustomizationData.sidebar_position_flag = "default"
if (!widgetCustomizationData.logo_url || widgetCustomizationData.logo_url === "default")
    widgetCustomizationData.logo_url = "none"
if (!widgetCustomizationData.badge_url)
  widgetCustomizationData.badge_url = "default"

 if(widgetCustomizationData.color_theme === "defaultTheme"){
    document.body.classList.add("defaultTheme");
  }

  bodyStyle.textContent = `
    :root {
      --backgroundClr1: ${widgetCustomizationData.background_clr1 !== "default" ? widgetCustomizationData.background_clr1 : lclObj["background_clr1"]};
      --backgroundClr2: ${widgetCustomizationData.background_clr2 !== "default" ? widgetCustomizationData.background_clr2 : lclObj["background_clr2"]};
      --backgroundClr3: ${widgetCustomizationData.background_clr3 !== "default" ? widgetCustomizationData.background_clr3 : lclObj["background_clr3"]};
      --mainBtnClr1: ${widgetCustomizationData.main_btn_clr1 !== "default" ? widgetCustomizationData.main_btn_clr1 : lclObj["main_btn_clr1"]};
      --mainBtnClr2: ${widgetCustomizationData.main_btn_clr2 !== "default" ? widgetCustomizationData.main_btn_clr2 : lclObj["main_btn_clr2"]};
      --mainBtnClr3: ${widgetCustomizationData.main_btn_clr3 !== "default" ? widgetCustomizationData.main_btn_clr3 : lclObj["main_btn_clr3"]};
      --mainBtnClr4: ${widgetCustomizationData.main_btn_clr4 !== "default" ? widgetCustomizationData.main_btn_clr4 : lclObj["main_btn_clr4"]};
      --mainBtnClr5: ${widgetCustomizationData.main_btn_clr5 !== "default" ? widgetCustomizationData.main_btn_clr5 : lclObj["main_btn_clr5"]};
      --mainBtnShadowClr: ${widgetCustomizationData.main_btn_shadow_clr !== "default" ? widgetCustomizationData.main_btn_shadow_clr : lclObj["main_btn_shadow_clr"]};
      --tooltipBackgroundClr: ${widgetCustomizationData.tool_tip_background_clr !== "default" ? widgetCustomizationData.tool_tip_background_clr : lclObj["tool_tip_background_clr"]};
      --normalTextClr: ${widgetCustomizationData.normal_text_clr !== "default" ? widgetCustomizationData.normal_text_clr : lclObj["normal_text_clr"]};
      --ellipseTop: ${widgetCustomizationData.ellipse_top !== "default" ? widgetCustomizationData.ellipse_top : lclObj["ellipse_top"]};
      --ellipseBottom: ${widgetCustomizationData.ellipse_bottom !== "default" ? widgetCustomizationData.ellipse_bottom : lclObj["ellipse_bottom"]};
      --arrowBackgroundClr: ${widgetCustomizationData.arrow_background_clr !== "default" ? widgetCustomizationData.arrow_background_clr : lclObj["arrow_background_clr"]};
      --colorfulTextClr1: ${widgetCustomizationData.colorful_text_clr1 !== "default" ? widgetCustomizationData.colorful_text_clr1 : lclObj["colorful_text_clr1"]};
      --colorfulTextClr2: ${widgetCustomizationData.colorful_text_clr2 !== "default" ? widgetCustomizationData.colorful_text_clr2 : lclObj["colorful_text_clr2"]};
      --colorfulTextClr3: ${widgetCustomizationData.colorful_text_clr3 !== "default" ? widgetCustomizationData.colorful_text_clr3 : lclObj["colorful_text_clr3"]};
      --negativeClr: ${widgetCustomizationData.negative_clr !== "default" ? widgetCustomizationData.negative_clr : lclObj["negative_clr"]};
      --positiveClr: ${widgetCustomizationData.positive_clr !== "default" ? widgetCustomizationData.positive_clr : lclObj["positive_clr"]};
      --transparentWClr: ${widgetCustomizationData.transparent_wclr !== "default" ? widgetCustomizationData.transparent_wclr : lclObj["transparent_wclr"]};
      --markdownBackgroundClr1: ${widgetCustomizationData.markdown_background_clr1 !== "default" ? widgetCustomizationData.markdown_background_clr1 : lclObj["markdown_background_clr1"]};
      --markdownBackgroundClr2: ${widgetCustomizationData.markdown_background_clr2 !== "default" ? widgetCustomizationData.markdown_background_clr2 : lclObj["markdown_background_clr2"]};
      --markdownBackgroundClr3: ${widgetCustomizationData.markdown_background_clr3 !== "default" ? widgetCustomizationData.markdown_background_clr3 : lclObj["markdown_background_clr3"]};
      --markdownBorderClr: ${widgetCustomizationData.markdown_border_clr !== "default" ? widgetCustomizationData.markdown_border_clr : lclObj["markdown_border_clr"]};
      --markdownTextClr1: ${widgetCustomizationData.markdown_text_clr1 !== "default" ? widgetCustomizationData.markdown_text_clr1 : lclObj["markdown_text_clr1"]};
      --markdownTextClr2: ${widgetCustomizationData.markdown_text_clr2 !== "default" ? widgetCustomizationData.markdown_text_clr2 : lclObj["markdown_text_clr2"]};
      --markdownTextClr3: ${widgetCustomizationData.markdown_text_clr3 !== "default" ? widgetCustomizationData.markdown_text_clr3 : lclObj["markdown_text_clr3"]};
      --markdownTextClr4: ${widgetCustomizationData.markdown_text_clr4 !== "default" ? widgetCustomizationData.markdown_text_clr4 : lclObj["markdown_text_clr4"]};
      --markdownTextClr5: ${widgetCustomizationData.markdown_text_clr5 !== "default" ? widgetCustomizationData.markdown_text_clr5 : lclObj["markdown_text_clr5"]};
      --markdownTextClr6: ${widgetCustomizationData.markdown_text_clr6 !== "default" ? widgetCustomizationData.markdown_text_clr6 : lclObj["markdown_text_clr6"]};
      --markdownTextClr7: ${widgetCustomizationData.markdown_text_clr7 !== "default" ? widgetCustomizationData.markdown_text_clr7 : lclObj["markdown_text_clr7"]};
      --boxShadowClr1: ${widgetCustomizationData.box_shadow_Clr1 !== "default" ? widgetCustomizationData.box_shadow_Clr1 : lclObj["box_shadow_Clr1"]};
      --boxShadowClr2: ${widgetCustomizationData.box_shadow_Clr2 !== "default" ? widgetCustomizationData.box_shadow_Clr2 : lclObj["box_shadow_Clr2"]};
      --textBorderClr1: ${widgetCustomizationData.text_border_clr1 !== "default" ? widgetCustomizationData.text_border_clr1 : lclObj["text_border_clr1"]};
      --textBorderClr2: ${widgetCustomizationData.text_border_clr2 !== "default" ? widgetCustomizationData.text_border_clr2 : lclObj["text_border_clr2"]};
      --textShadowClr: ${widgetCustomizationData.text_shadow_clr !== "default" ? widgetCustomizationData.text_shadow_clr : lclObj["text_shadow_clr"]};
      --questBackgroundClr1: ${widgetCustomizationData.quest_background_clr1 !== "default" ? widgetCustomizationData.quest_background_clr1 : lclObj["quest_background_clr1"]};
      --questBackgroundClr2: ${widgetCustomizationData.quest_background_clr2 !== "default" ? widgetCustomizationData.quest_background_clr2 : lclObj["quest_background_clr2"]};
      --userBackgroundClr: ${widgetCustomizationData.user_background_clr !== "default" ? widgetCustomizationData.user_background_clr : lclObj["user_background_clr"]};
      --userShadowClr1: ${widgetCustomizationData.user_shadow_clr1 !== "default" ? widgetCustomizationData.user_shadow_clr1 : lclObj["user_shadow_clr1"]};
      --userShadowClr2: ${widgetCustomizationData.user_shadow_clr2 !== "default" ? widgetCustomizationData.user_shadow_clr2 : lclObj["user_shadow_clr2"]};
      --questionBtnBorderClr1: ${widgetCustomizationData.question_btn_border_clr1 !== "default" ? widgetCustomizationData.question_btn_border_clr1 : lclObj["question_btn_border_clr1"]};
      --questionBtnBorderClr2: ${widgetCustomizationData.question_btn_border_clr2 !== "default" ? widgetCustomizationData.question_btn_border_clr2 : lclObj["question_btn_border_clr2"]};
      --checkedBorderClr1: ${widgetCustomizationData.checked_border_clr1 !== "default" ? widgetCustomizationData.checked_border_clr1 : lclObj["checked_border_clr1"]};
      --checkedBorderClr2: ${widgetCustomizationData.checked_border_clr2 !== "default" ? widgetCustomizationData.checked_border_clr2 : lclObj["checked_border_clr2"]};
      --checkedShadowClr: ${widgetCustomizationData.checked_shadow_clr !== "default" ? widgetCustomizationData.checked_shadow_clr : lclObj["checked_shadow_clr"]};
      --codeBlockBackgroundClr: ${widgetCustomizationData.codeBlock_background_clr !== "default" ? widgetCustomizationData.codeBlock_background_clr : lclObj["codeBlock_background_clr"]};
      --newChatBtnClr: ${widgetCustomizationData.newchat_btn_clr !== "default" ? widgetCustomizationData.newchat_btn_clr : lclObj["newchat_btn_clr"]};
      --sendButtonClr: ${widgetCustomizationData.send_button_clr !== "default" ? widgetCustomizationData.send_button_clr : lclObj["send_button_clr"]};
      --stopButtonClr: ${widgetCustomizationData.stop_button_clr !== "default" ? widgetCustomizationData.stop_button_clr : lclObj["stop_button_clr"]};
      --iconsBackgroundClr: ${widgetCustomizationData.icons_background_clr !== "default" ? widgetCustomizationData.icons_background_clr : lclObj["icons_background_clr"]};
      --errorBackgroundClr: ${widgetCustomizationData.error_background_clr !== "default" ? widgetCustomizationData.error_background_clr : lclObj["error_background_clr"]};
      --errorShadowClr: ${widgetCustomizationData.error_shadow_clr !== "default" ? widgetCustomizationData.error_shadow_clr : lclObj["error_shadow_clr"]};
      --errorClr: ${widgetCustomizationData.error_clr !== "default" ? widgetCustomizationData.error_clr : lclObj["error_clr"]};
      --overlayMenuBackgroundClr: ${widgetCustomizationData.overlay_menu_background_clr !== "default" ? widgetCustomizationData.overlay_menu_background_clr : lclObj["overlay_menu_background_clr"]};
      --overlayClr: ${widgetCustomizationData.overlay_clr !== "default" ? widgetCustomizationData.overlay_clr : lclObj["overlay_clr"]};
      --disclaimerBackgroundClr: ${widgetCustomizationData.disclaimer_background_clr !== "default" ? widgetCustomizationData.disclaimer_background_clr : lclObj["disclaimer_background_clr"]};
      --disclaimerTextClr: ${widgetCustomizationData.disclaimer_text_clr !== "default" ? widgetCustomizationData.disclaimer_text_clr : lclObj["disclaimer_text_clr"]};
      --initQuestTextClr: ${widgetCustomizationData.init_quest_text_clr !== "default" ? widgetCustomizationData.init_quest_text_clr : lclObj["init_quest_text_clr"]};
      --questTextClr: ${widgetCustomizationData.quest_text_clr !== "default" ? widgetCustomizationData.quest_text_clr : lclObj["quest_text_clr"]};
      --shineVerboseEffectClr: ${widgetCustomizationData.shine_verbose_effect_clr !== "default" ? widgetCustomizationData.shine_verbose_effect_clr : lclObj["shine_verbose_effect_clr"]};
    }
  `;

widgetCustomizationData.reset_all_styles = false
if (!widgetCustomizationData.reset_all_styles) {
  if (widgetCustomizationData.sidebar_position_flag === "right") {
    document.body.classList.add("sidebarpositionflag")
  }

widgetCustomizationData.ticker_flag = "FALSE";
  if (widgetCustomizationData.ticker_flag) {
    document.body.classList.add("hideTicker")
  }

}

  const contextValueOut = {
  userId: userId||"defaultUser",
  userClass: user_class||"default",
  logourl: widgetCustomizationData ? widgetCustomizationData.logo_url : "none",
  badgeurl: widgetCustomizationData ? widgetCustomizationData.badge_url : "none",
  error_message: error_message,
  should_present_legal_banner: should_present_legal_banner,
  client_id: client_id,
  client_token: client_token,
  article_index: article_index,
  follow_up_question: follow_up_question,
  proxy: proxy,
  welcome_message: welcome_message,
  language_for_widget: languageForWidget,
  floatingState:floatingState,
  asset_type: asset_type,
  asset_symbol: asset_symbol,
  follow_up_questions:follow_up_questions,
  language_for_chat:languageForChat,
    root: root

  };

  return {contextValueOut }
};